import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import customizer from './customizer/';
import auth from './auth/';
import navbar from './navbar/Index';
import profile from './profile/profile';
import options from './options';
import toastReducer from './toast/toast';
import responseLoading from './responseLoading/responseLoading';
import benchmark from './benchmark/benchmark';
import fetcher from './fetcher';

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  blacklist: ['emailToken'],
};

const rootReducer = combineReducers({
  customizer: customizer,
  auth: persistReducer(authPersistConfig, auth),
  fetcher: fetcher,
  navbar: navbar,
  profile: profile,
  toastReducer: toastReducer,
  options: options,
  responseLoading: responseLoading,
  benchmark: benchmark,
});

export default rootReducer;
